@for (notification of notifications$ | async; track notification.id) {
  <div class="notification">
    <div class="content" [innerHTML]="notification.message"></div>
    <button
      aria-label="Dismiss notification"
      class="close"
      inlineSVG="/assets/icons/close.svg"
      type="button"
      (click)="dismiss(notification.id)"
    ></button>
  </div>
}
